import types from "./types";

const INITIAL_STATE = {
	suggestion: null,
	suggestionError: null,
	suggestionLoading: false,

	//create
	createsuggestion: null,
	createsuggestionError: null,
	createsuggestionLoading: false,

	//update
	updatesuggestion: null,
	updatesuggestionError: null,
	updatesuggestionLoading: false,

	//delete
	deletesuggestion: null,
	deletesuggestionError: null,
	deletesuggestionLoading: false,

	//single item

	singleItem: null,
};

const SuggestionReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_SUGGESTION_START:
			return {
				...state,
				suggestion: null,
				suggestionError: null,
				suggestionLoading: true,
			};
		case types.GET_SUGGESTION_SUCCESS:
			return {
				...state,
				suggestion: action.payload,
				suggestionLoading: false,
			};
		case types.GET_SUGGESTION_ERROR:
			return {
				...state,
				suggestionError: action.payload,
				suggestionLoading: false,
			};
		case types.GET_SUGGESTION_RESET:
			return {
				...state,
				suggestionError: null,
				suggestionLoading: false,
			};
		//create

		case types.CREATE_SUGGESTION_START:
			return {
				...state,
				createsuggestion: null,
				createsuggestionError: null,
				createsuggestionLoading: true,
			};
		case types.CREATE_SUGGESTION_SUCCESS:
			return {
				...state,
				createsuggestion: action.payload,
				createsuggestionLoading: false,
			};
		case types.CREATE_SUGGESTION_ERROR:
			return {
				...state,
				createsuggestionError: action.payload,
				createsuggestionLoading: false,
			};
		case types.CREATE_SUGGESTION_RESET:
			return {
				...state,
				createsuggestionError: null,
				createsuggestionLoading: false,
			};
		//delete

		case types.DELETE_SUGGESTION_START:
			return {
				...state,
				deletesuggestion: null,
				deletesuggestionError: null,
				deletesuggestionLoading: true,
			};
		case types.DELETE_SUGGESTION_SUCCESS:
			return {
				...state,
				deletesuggestion: action.payload,
				deletesuggestionLoading: false,
			};
		case types.DELETE_SUGGESTION_ERROR:
			return {
				...state,
				deletesuggestionError: action.payload,
				deletesuggestionLoading: false,
			};
		case types.DELETE_SUGGESTION_RESET:
			return {
				...state,
				deletesuggestion: null,
				deletesuggestionError: null,
				deletesuggestionLoading: false,
			};

		//update
		case types.UPDATE_SUGGESTION_START:
			return {
				...state,
				updatesuggestion: null,
				updatesuggestionError: null,
				updatesuggestionLoading: true,
			};
		case types.UPDATE_SUGGESTION_SUCCESS:
			return {
				...state,
				updatesuggestion: action.payload,
				updatesuggestionLoading: false,
			};
		case types.UPDATE_SUGGESTION_ERROR:
			return {
				...state,
				updatesuggestionError: action.payload,
				updatesuggestionLoading: false,
			};
		case types.UPDATE_SUGGESTION_RESET:
			return {
				...state,
				updatesuggestion: null,
				updatesuggestionError: null,
				updatesuggestionLoading: false,
			};

		default:
			return { ...state };
	}
};

export default SuggestionReducer;
